import React, { useEffect, useState } from 'react'
import FilterNetwork from '../components/provider-network/FilterNetwork';
import { Spinner } from '../components/common/atoms';
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import ToggleButton from '../components/common/atoms/ToggleButton';
import { appApi } from '../services';
import ProviderList from '../components/provider-network/ProviderList';
import ahc_home from '../assets/images/ahc_home.svg'
import ahc_at_center from '../assets/images/ahc_at_center.svg'
import dental_home from '../assets/images/dental_home.svg'
import dental_at_center from '../assets/images/dental_at_center.svg'
import vision_home from '../assets/images/vision_home.svg'
import vision_at_center from '../assets/images/vision_at_center.svg'

const MAP_PINS = {
  body_home_collection: ahc_home,
  body_at_center: ahc_at_center,
  vision_home_collection: vision_home,
  vision_at_center: vision_at_center,
  dental_home_collection: dental_home,
  dental_at_center: dental_at_center
}

const ProviderNetwork = () => {
  const DEFAULT_LATITUDE = 20.5937
  const DEFAULT_LONGITUDE = 78.9629
  const [showNonClusterView, setShowNonClusterView] = useState(false)
  const [value, setValue] = useState(undefined)
  const [clearInput, setClearInput] = useState(false)
  const [serviceType, setServiceType] = useState('')
  const [serviceMode, setServiceMode] = useState('')
  const [latLng, setLatLng] = useState({ lat: DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE, pincode: '' })
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false)
  const [state, setState] = useState({
    loading: true,
    data: undefined,
  })

  const selectedLocationPresent = latLng.lat && latLng.lng && latLng.lat !== DEFAULT_LATITUDE && latLng.lng !== DEFAULT_LONGITUDE

  useEffect(() => {
    loadGoogleMapsScript();
  }, []);
  
  useEffect(() => {
    if(typeof value === 'string' && value.length === 0 && clearInput) return; 
    fetchData()
  }, [serviceMode, serviceType, latLng.lat, latLng.lng])

  useEffect(() => {
    if(clearInput && typeof value === 'string' && value.length === 0) {
      fetchData()
    }
  }, [value])

  useEffect(() => {
    if(!state.loading) {
      onMapLoad()
    }
  }, [state.loading, selectedLocationPresent, state.data, showNonClusterView])

  const loadGoogleMapsScript = () => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => setGoogleMapsLoaded(true);
    document.head.appendChild(script);
  };

  const onMapLoad = () => {
    const script = document.createElement("script");
    script.src = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => initMap();
  }

  const updateServices = (value, name) => {
    if(name === 'service_types') {
      setServiceType(value)
    } else if (name === 'service_modes') {  
      setServiceMode(value); 
    }
  } 

  const fetchData = () => {
    setState({...state, loading: true})
    const queryParams = new URLSearchParams();
    if (serviceType.length > 0) {
      queryParams.append('service_types', serviceType.join(','));
    }
   
    if (serviceMode) {
      queryParams.append('service_modes', serviceMode);
    }
    
    if(latLng.lat && latLng.lng && latLng.lat !== DEFAULT_LATITUDE && latLng.lng !== DEFAULT_LONGITUDE ){
      queryParams.append('latitude', latLng.lat);
      queryParams.append('longitude', latLng.lng);
    }

    if(latLng.pincode) {
      queryParams.append('pincode', latLng.pincode);
    }

    const apiUrl = window.API_URL + 'corporate/provider_service_network';
    const queryString = queryParams.toString();

    let urlWithQueryParams = apiUrl;
    if (queryString) {
      urlWithQueryParams += `?${queryString}`;
    }
    appApi.providerServiceNetwork({url: urlWithQueryParams },
      (res) => {
        setState({...state, data: res?.data, loading: false})
      },
      (error) => { 
        console.log(error)
        setState({...state, loading: false})
      }
    )
  }

  const mapStyles = {
    height: "550px",
    width: "100%",
  };


  const initMap = () => {
    const locations = state?.data?.provider_locations || []
    let mapContainer = document.getElementById("map");
 
    if (!mapContainer) {
      mapContainer = document.createElement("div");
      console.log("Map container not found");
    }
    const map = new window.google.maps.Map(mapContainer, {
      center: { lat: latLng.lat, lng: latLng.lng },
      zoom: selectedLocationPresent ? 10 : 5
    });

    // Initialize MarkerClusterer
    const markerCluster = new window.MarkerClusterer(map, [], {
      imagePath:
        "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
    });

    // Add markers to the cluster
    locations?.forEach((location) => {
      const marker = new window.google.maps.Marker({
        position: { lat: parseFloat(location?.latitude), lng: parseFloat(location?.longitude) },
        icon: MAP_PINS[location.icon_name],
      });
      markerCluster.addMarker(marker);
    });
  };

  const setLocation = (lat, lng, pincode) => {
    setLatLng({...latLng, lat: lat, lng: lng, pincode: pincode})
  }

  const onSelectInput = (value) => {
    if(typeof value === 'string' && value.length === 0) {
      setClearInput(true)
      setLatLng({...latLng, lat: DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE, pincode: ''})
      setValue(undefined)
    } else {
      setValue(value)
    }
  }

  return (
    <div className="p-2">
      <Spinner visible={state.loading}>
      <div className="flex w-full" style={{ height: "100px"}}>
        {googleMapsLoaded && <FilterNetwork 
          serviceType={serviceType}
          serviceMode={serviceMode}
          updateServices={updateServices}
          setLocation={setLocation}
          value={value}
          setValue={onSelectInput}
          loading={state.loading}
        />}
      </div>
        <div className="flex">
          <div style={{ width: "70%" }}>
            <div className="flex justify-end my-2.5 mr-4">  
              <label className="font-semibold mb-4 mr-4 block text-gray-700">Cluster view</label>
              <ToggleButton name='showNonClusterView' toggle={!showNonClusterView} onChangeHandler={() => setShowNonClusterView(!showNonClusterView)}/>
            </div>
            {!showNonClusterView ? <div id="map" style={mapStyles}>
              <LoadScript googleMapsApiKey="AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ" />
            </div> :  
              <LoadScript googleMapsApiKey="AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ">
                <GoogleMap
                  mapContainerStyle={mapStyles}
                  zoom={selectedLocationPresent ? 10 : 5}
                  center = {{ lat: latLng.lat, lng: latLng.lng}}
                >
                  {state?.data?.provider_locations?.map((location, index) => (            
                    <Marker
                      key={index}
                      position={{ lat: parseFloat(location?.latitude), lng: parseFloat(location?.longitude) }}
                      icon={MAP_PINS[location.icon_name]}
                    />
                  ))}
                </GoogleMap>
              </LoadScript>
            }
          </div>
          <div style={{ width: "30%"}}>
            <p className='font-semibold ml-4 text-gray-700 mb-2 mt-2'>Provider List</p>
            <ProviderList data={state?.data?.provider_locations}/>
          </div>
        </div>
      </Spinner>
    </div>
  );
};

export default ProviderNetwork